import { render, staticRenderFns } from "./accountStep5.vue?vue&type=template&id=66066f14&"
import script from "./accountStep5.vue?vue&type=script&lang=js&"
export * from "./accountStep5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports